import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingWizard from "@/components/OnboardingWizard";
import { useAuth } from "@/contexts/auth-context";

const OnboardingPage = () => {
  const navigate = useNavigate();
  const { user, updateVenueId } = useAuth();
  const [pendingNavigate, setPendingNavigate] = useState(false);

  useEffect(() => {
    if (pendingNavigate && user?.venueId) {
      navigate("/app");
    }
  }, [pendingNavigate, user?.venueId, navigate]);

  const handleComplete = (venueId: string) => {
    localStorage.setItem("onboarding_completed", "true");
    if (venueId) {
      updateVenueId(venueId);
      setPendingNavigate(true);
    } else {
      navigate("/app");
    }
  };

  return <OnboardingWizard onComplete={handleComplete} />;
};

export default OnboardingPage;
